import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { getSubscriptionTypesPublic } from "../services/authService";
import image1 from "../images/image856.png";
import image2 from "../images/image867.png";
import image3 from "../images/image878.png";
import image4 from "../images/image950.png";
import heroScreen1 from "../images/ScreenTelephone1GymNote.png";
import heroScreen2 from "../images/ScreenTelephone2GymNote.png";
import logo from "../images/favicon.png";
import playstore from "../images/playstore.png";
import appstore from "../images/appstore.svg";
import circleBackground from "../images/circleBackGround.svg";
import imageCoach1 from "../images/imageCoach1.png";
import imageCoach2 from "../images/imageCoach2.png";
import imageCoach3 from "../images/imageCoach3.png";

function FadeInSection({ children, className = "" }) {
	const ref = useRef(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{ threshold: 0.15 }
		);
		if (ref.current) observer.observe(ref.current);
		return () => observer.disconnect();
	}, []);

	return (
		<div
			ref={ref}
			className={`fade-in-section ${visible ? "visible" : ""} ${className}`}
		>
			{children}
		</div>
	);
}

// Hardcoded fallback for graceful degradation
const FALLBACK_PLANS = {
	starter: ["Entraînements illimités", "Synchronisation cloud", "Templates personnalisés", "Dashboard mobile", "Jusqu'à 10 élèves", "Planification avancée"],
	pro: ["Entraînements illimités", "Synchronisation cloud", "Templates personnalisés", "Dashboard mobile", "Planification avancée", "Dashboard Coach web", "Jusqu'à 100 élèves"],
};

function Home() {
	const [billingPeriod, setBillingPeriod] = useState("monthly");
	const [plans, setPlans] = useState(null);

	useEffect(() => {
		const fetchPlans = async () => {
			const result = await getSubscriptionTypesPublic();
			if (result.success) {
				setPlans(result.types);
			}
		};
		fetchPlans();
	}, []);

	return (
		<div className="page">
			<div className="page-content">
				<div className="hero-banner">
					<div className="hero-content">
						<div className="hero-text">
							<h1 className="hero-title">
								<span className="highlight">G</span>ym
								<span className="highlight">N</span>ote
							</h1>
							<p className="hero-description">
								GymNote est une application simple et intuitive à utiliser à la
								salle de sport. Elle va te permettre de noter tes performances
								sur chaque série de chaque exercice, séance après séance.
							</p>
						</div>
						<div className="hero-logo-box hero-logo-mobile">
							<img src={logo} alt="Gymnote logo" className="hero-logo" />
						</div>
					</div>
					<div className="hero-stores-mobile">
						<a
							href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={playstore}
								alt="Get it on Play Store"
								className="hero-playstore"
							/>
						</a>
						<a
							href="https://apps.apple.com/fr/app/gymnote-suivi-muscu-coach/id6470710692"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={appstore}
								alt="Download on the App Store"
								className="hero-playstore"
							/>
						</a>
					</div>
					<div className="hero-images">
						<img
							src={heroScreen1}
							alt="Gymnote screenshot"
							className="hero-image"
						/>
						<img
							src={heroScreen2}
							alt="Gymnote screenshot"
							className="hero-image"
						/>
					</div>
					<div className="hero-right">
						<div className="hero-logo-box">
							<img src={logo} alt="Gymnote logo" className="hero-logo" />
						</div>
						<a
							href="https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={playstore}
								alt="Get it on Play Store"
								className="hero-playstore"
							/>
						</a>
						<a
							href="https://apps.apple.com/fr/app/gymnote-suivi-muscu-coach/id6470710692"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={appstore}
								alt="Download on the App Store"
								className="hero-playstore"
							/>
						</a>
					</div>
				</div>
				<FadeInSection>
					<div className="screenshots-section">
						<div className="screenshot-item screen-high">
							<img
								src={image2}
								alt="Gymnote screenshot"
								className="screen-image"
							/>
							<p className="screenshot-subtitle">CHALLENGE-TOI À CHAQUE SÉANCE</p>
							<p className="screenshot-text">
								Tes anciennes perfs s'affichent directement, à toi de les dépasser
								!
							</p>
						</div>
						<div className="screenshot-item screen-low">
							<img
								src={image3}
								alt="Gymnote screenshot"
								className="screen-image"
							/>
							<p className="screenshot-subtitle">
								MOTIVE-TOI EN SUIVANT TES GYMBRO
							</p>
							<p className="screenshot-text">
								Ajoute tes amis pour suivre leurs records et leurs performances
								sur la semaine !
							</p>
						</div>
						<div className="screenshot-item screen-mid">
							<img
								src={image4}
								alt="Gymnote screenshot"
								className="screen-image"
							/>
							<p className="screenshot-subtitle">PERSONNALISE TES EXERCICES</p>
							<p className="screenshot-text">
								Ajoute et ajuste tes exercices selon tes objectifs et tes
								préférences !
							</p>
						</div>
					</div>
				</FadeInSection>
				<FadeInSection>
					<div className="cta-section">
						<img src={image1} alt="Gymnote screenshot" className="cta-image" />
						<div className="cta-content">
							<h2 className="cta-title">
								<span className="highlight">G</span>ym
								<span className="highlight">N</span>ote
							</h2>
							<p className="cta-subtitle">PROPOSE UNE FONCTIONNALITÉ UNIQUE</p>
							<p className="cta-feature">LE MODE COACH</p>
							<p className="cta-tag">COULEURS D'INTERFACE DIFFÉRENTES</p>
							<p className="cta-tag">UN SUIVI EN TEMPS RÉEL</p>
							<p className="cta-description">
								Le Mode Coach est une innovation pour le coaching en musculation.
								Passe ton profil en mode coach puis consulte, annote, et organise
								les séances de tes élèves en temps réel. Assure un suivi
								millimétré de leurs performances pour maximiser leur progression,
								tout en économisant un maximum de ton temps précieux !
							</p>
						</div>
					</div>
				</FadeInSection>
				<FadeInSection>
					<div className="coach-features-section">
						<div className="coach-feature-item">
							<img
								src={imageCoach3}
								alt="Ajoute tes élèves"
								className="coach-feature-image"
							/>
							<p className="coach-feature-title">AJOUTE TES ÉLÈVES</p>
							<p className="coach-feature-text">
								Tes élèves ont juste à installer GymNote et accepter ton
								invitation !
							</p>
						</div>
						<div className="coach-feature-item">
							<img
								src={imageCoach1}
								alt="Ajoute des notes"
								className="coach-feature-image"
							/>
							<p className="coach-feature-title">PRÉPARE LEURS ENTRAÎNEMENTS</p>
							<p className="coach-feature-text">
								Choix des exercices, nombre de séries, charges de travail, c'est
								toi qui gères !
							</p>
						</div>
						<div className="coach-feature-item">
							<img
								src={imageCoach2}
								alt="Suit ses performances"
								className="coach-feature-image"
							/>
							<p className="coach-feature-title">SUIS SES PERFORMANCES</p>
							<p className="coach-feature-text">
								Ajuste son programme en temps réel pour une progression optimale !
							</p>
						</div>
					</div>
				</FadeInSection>
				<FadeInSection>
					<div className="orange-banner">
						<h2 className="orange-title">ABONNEMENTS</h2>
						<div className="billing-toggle billing-toggle-home">
							<span className={billingPeriod === "monthly" ? "active" : ""}>Mensuel</span>
							<label className="toggle-switch">
								<input
									type="checkbox"
									checked={billingPeriod === "yearly"}
									onChange={() => setBillingPeriod(billingPeriod === "monthly" ? "yearly" : "monthly")}
								/>
								<span className="toggle-slider"></span>
							</label>
							<span className={billingPeriod === "yearly" ? "active" : ""}>
								Annuel <span className="billing-savings">-17%</span>
							</span>
						</div>
						<div className="pricing-cards">
							{(() => {
								const starterPlans = plans?.filter(p => p.libelle?.toLowerCase().includes("starter") && p.prix > 0) || [];
								const proPlans = plans?.filter(p => p.libelle?.toLowerCase().includes("pro") && p.prix > 0) || [];
								const starterMonthly = starterPlans.find(p => p.dureeMois === 1);
								const starterYearly = starterPlans.find(p => p.dureeMois === 12);
								const proMonthly = proPlans.find(p => p.dureeMois === 1);
								const proYearly = proPlans.find(p => p.dureeMois === 12);

								const starterFeatures = (starterMonthly || starterYearly)?.fonctionnalites?.map(f => f.libelle) || FALLBACK_PLANS.starter;
								const proFeatures = (proMonthly || proYearly)?.fonctionnalites?.map(f => f.libelle) || FALLBACK_PLANS.pro;

								// Starter: switch between monthly/yearly
								const starterPlan = billingPeriod === "yearly" && starterYearly ? starterYearly : starterMonthly;
								const starterPrice = starterPlan?.prix ?? (billingPeriod === "monthly" ? 9.99 : 99.99);

								// Pro: switch between monthly/yearly
								const proPlan = billingPeriod === "yearly" && proYearly ? proYearly : proMonthly;
								const proPrice = proPlan?.prix ?? (billingPeriod === "monthly" ? 19.99 : 199.99);

								const starterIsYearly = starterPlan?.dureeMois === 12;
								const proIsYearly = proPlan?.dureeMois === 12;

								return (
									<>
										<div className="pricing-card">
											<p className="pricing-name">Starter</p>
											<p className="pricing-price">
												{starterPrice}€<span>{starterIsYearly ? "/an" : "/mois"}</span>
											</p>
											{starterIsYearly && (
												<p className="pricing-equivalent">soit {(starterPrice / 12).toFixed(2)}€/mois</p>
											)}
											<ul className="pricing-features">
												{starterFeatures.map((f, i) => <li key={i}>{f}</li>)}
											</ul>
										</div>
										<div className="pricing-card pricing-card-featured">
											<p className="pricing-name">Pro</p>
											<p className="pricing-price">
												{proPrice}€<span>{proIsYearly ? "/an" : "/mois"}</span>
											</p>
											{proIsYearly && (
												<p className="pricing-equivalent">soit {(proPrice / 12).toFixed(2)}€/mois</p>
											)}
											<ul className="pricing-features">
												{proFeatures.map((f, i) => <li key={i}>{f}</li>)}
											</ul>
										</div>
									</>
								);
							})()}
						</div>
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Home;
